module.exports = __webpack_public_path__ + "img/img_festa4.f4e7cafc.jpg";